import { useMarkAsReadMutation } from '@/store/query/notification';
import { Button } from '@chakra-ui/react';

export const SendMessageButton = ({ interviewUrl, notification, ...props }) => {
  const [markAsRead] = useMarkAsReadMutation();

  const handleSendMessage = () => {
    markAsRead({ id: notification?.id });
    window.open(`${interviewUrl}?send-message=true`, '_self');
  };

  return (
    <Button variant="secondary" flex="1" onClick={handleSendMessage} {...props}>
      Send message
    </Button>
  );
};
